export default "__VITE_ASSET__DIVZL7Vg__"